<template>
  <div>
  <div v-if="field.slug == 'fotos'">
  <TransitionGroup name="list">
  <div v-for="doc in formNewStore[field.slug]" :key="'file-' + doc.id" class="space-y-1">
    <File :doc="doc"></File>
    </div>
    </TransitionGroup>
  </div>
  <div v-else>
    <File v-if="Object.entries(formNewStore[field.slug]).length > 0" :doc="formNewStore[field.slug]"></File>
  </div>
</div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useFormNewStore } from '@/stores/formNew.js'



import File from './File.vue'
const formNewStore = useFormNewStore()



const props = defineProps({
  field: Object
})
</script>

<style>
.list-move, /* apply transition to moving elements */
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.list-leave-active {
  position: absolute;
}


.dropzone,
.dropzone * {
    box-sizing: border-box
}

.dropzone {
    @apply relative w-full;

    
}

.dropzone .dz-button {
    @apply block w-full;

    
}

.dropzone .dz-preview {
    @apply bg-verde-50 w-full p-4 rounded-2xl mt-1;
    position: relative;
    /* display: inline-block;
    width: 120px;
    margin: .5em */

    .dz-image {
      @apply absolute top-4 left-4 size-10 rounded-lg overflow-hidden;
    }
    .dz-image:after {
        content: '';
        position: absolute;
        inset: 0;
        background-size: cover;
        /* background-size: 75%; */
        background-position: left center;
        background-repeat: no-repeat;
    }

    .type-pdf .dz-image:after {
      background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDU2IDU2Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjNTdhYzM2OwogICAgICB9CgogICAgICAuY2xzLTEsIC5jbHMtMiwgLmNscy0zIHsKICAgICAgICBzdHJva2Utd2lkdGg6IDBweDsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsOiAjMmM1NDIwOwogICAgICB9CgogICAgICAuY2xzLTMgewogICAgICAgIGZpbGw6ICNmZmY7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTM2LjksMEg3LjlDNy4yLDAsNi40LjYsNi40LDEuOXY1My4xYzAsLjQuNiwxLDEuNSwxaDQwLjFjLjcsMCwxLjUtLjYsMS41LTFWMTNjMC0uNywwLS45LS4zLTEuMUwzNy43LjNDMzcuNCwwLDM3LjIsMCwzNi45LDBoMFoiLz4KICA8cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0zNy40LDB2MTEuOWgxMS45TDM3LjQsMFoiLz4KICA8cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0xNy4zLDM0LjNoLTEuNnYtMTAuMmgyLjljLjQsMCwuOS4xLDEuMi4zLjQuMS43LjQsMS4xLjYuNC4zLjYuNi43LDEsLjMuNC4zLjkuMywxLjIsMCwuNS0uMSwxLS4zLDEuNC0uMS40LS40LjctLjcsMS0uMy4zLS42LjUtMS4xLjYtLjQuMS0uOS4zLTEuNS4zaC0xLjN2My44aC4zWk0xNy4zLDI1LjR2NGgxLjVjLjMsMCwuNCwwLC42LS4xcy40LS4xLjUtLjRjLjEtLjEuMy0uNC40LS42cy4xLS42LjEtMSwwLS40LS4xLS42YzAtLjMtLjEtLjQtLjMtLjYtLjEtLjMtLjQtLjQtLjYtLjUtLjMtLjEtLjYtLjMtMS0uM2gtMS4xWiIvPgogIDxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTMyLjIsMjguOWMwLC45LDAsMS41LS4zLDIuMS0uMS42LS40LDEuMS0uNiwxLjUtLjMuNC0uNi43LS45LDEtLjQuMy0uNi40LTEsLjVzLS42LDAtLjkuM2gtNC41di0xMC4yaDNjLjksMCwxLjYuMSwyLjIuNHMxLjEuNiwxLjYsMS4xYy40LjUuNywxLDEsMS41LjMuNy40LDEuMy40LDEuOGgwWk0yNy4zLDMzYzEuMSwwLDEuOS0uNCwyLjQtMS4xLjUtLjcuNy0xLjguNy0zLjFzMC0uOS0uMS0xLjItLjMtLjctLjYtMS4xYy0uMy0uNC0uNi0uNi0xLjEtLjctLjUtLjMtMS4xLS4zLTEuOS0uM2gtMXY3LjVoMS42WiIvPgogIDxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTM2LjIsMjUuNHYzLjFoNC4zdjEuMWgtNC4zdjQuNWgtMS42di0xMC4xaDYuM3YxLjNoLTQuNmMwLC4xLS4xLjEtLjEuMVoiLz4KPC9zdmc+);
    }
    .type-docx .dz-image:after,
    .type-doc .dz-image:after {
        background-image: url(data:image/svg+xml;base64,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);
    }
    .dz-details {
        @apply h-10 flex items-center justify-between px-14 overflow-hidden text-xs;
    
        .dz-size {
          @apply hidden;
      }
    }

    .dz-progress {
      @apply relative mt-2 h-[6px] w-full rounded-lg bg-neutral-200;

      .dz-upload {
        @apply absolute left-0 right-0 h-full rounded-lg bg-verde-500;
      }
    }

    .dz-success-mark,
    .dz-error-mark {
      @apply hidden;
    }

    .dz-remove {
      @apply absolute top-0 right-0 m-4 size-8 rounded-full text-verde-500 hover:text-verde-800 flex items-center justify-center;
    }

    &.dz-error {
      @apply bg-red-50;

      .dz-progress {
        .dz-upload {
          @apply bg-red-500;
        }
      }

      .dz-details {
        @apply pl-0;
      }

      .dz-image,
      .dz-image:after {
        display: none
      }

      .dz-remove {
        @apply text-red-500 hover:text-red-800;
      }
      
      .dz-error-message {
        @apply text-xs mt-2 text-red-500;
      }
    }
}
</style>
